/* ==========================================================================
   EL LABORATORIO DEL BAZAR - interacciones
   Vanilla, sin librerias. Un observer compartido. Respeta reduced-motion.
   ========================================================================== */
(function () {
  'use strict';

  var REDUCED =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. Reveals al hacer scroll ---------- */
  function initReveals(root) {
    var nodes = (root || document).querySelectorAll('.lb-rv:not([data-lb-seen])');
    if (!nodes.length) return;

    if (REDUCED || !('IntersectionObserver' in window)) {
      nodes.forEach(function (n) {
        n.setAttribute('data-lb-seen', '1');
        n.classList.add('is-in');
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.08 }
    );

    nodes.forEach(function (n) {
      n.setAttribute('data-lb-seen', '1');
      io.observe(n);
    });
  }

  /* ---------- 2. Escena sticky del cerebro ---------- */
  function initBrain(root) {
    var scenes = (root || document).querySelectorAll('[data-lb-brain]:not([data-lb-ready])');
    scenes.forEach(function (scene) {
      scene.setAttribute('data-lb-ready', '1');
      var steps = scene.querySelectorAll('[data-lb-brain-step]');
      var shots = scene.querySelectorAll('[data-lb-brain-shot]');
      var dots = scene.querySelectorAll('[data-lb-brain-dot]');
      if (!steps.length || !shots.length) return;

      function activate(i) {
        steps.forEach(function (s, k) {
          s.classList.toggle('is-on', k === i);
        });
        shots.forEach(function (s, k) {
          s.classList.toggle('is-on', k === i);
        });
        dots.forEach(function (d, k) {
          d.classList.toggle('is-on', k === i);
        });
      }

      activate(0);
      if (!('IntersectionObserver' in window)) return;

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            var i = parseInt(e.target.getAttribute('data-lb-brain-step'), 10);
            if (!isNaN(i)) activate(i);
          });
        },
        { rootMargin: '-45% 0px -45% 0px', threshold: 0 }
      );

      steps.forEach(function (s) {
        io.observe(s);
      });
    });
  }

  /* ---------- 3. FAQ acordeon ---------- */
  function initFaq(root) {
    var lists = (root || document).querySelectorAll('[data-lb-faq]:not([data-lb-ready])');
    lists.forEach(function (list) {
      list.setAttribute('data-lb-ready', '1');
      var solo = list.getAttribute('data-lb-faq') === 'solo';

      list.addEventListener('click', function (ev) {
        var btn = ev.target.closest('.lb-faq__q');
        if (!btn || !list.contains(btn)) return;
        var item = btn.closest('.lb-faq__item');
        var panel = item.querySelector('.lb-faq__a');
        var open = item.classList.contains('is-open');

        if (solo && !open) {
          list.querySelectorAll('.lb-faq__item.is-open').forEach(function (other) {
            close(other);
          });
        }
        open ? close(item) : show(item, panel);
      });

      function show(item, panel) {
        item.classList.add('is-open');
        item.querySelector('.lb-faq__q').setAttribute('aria-expanded', 'true');
        panel.style.height = panel.firstElementChild.offsetHeight + 'px';
        window.setTimeout(function () {
          if (item.classList.contains('is-open')) panel.style.height = 'auto';
        }, 440);
      }

      function close(item) {
        var panel = item.querySelector('.lb-faq__a');
        panel.style.height = panel.firstElementChild.offsetHeight + 'px';
        // forzar reflow para que la transicion arranque desde el alto real
        void panel.offsetHeight;
        item.classList.remove('is-open');
        item.querySelector('.lb-faq__q').setAttribute('aria-expanded', 'false');
        panel.style.height = '0px';
      }
    });
  }

  /* ---------- 4. Galeria de la ficha de producto ---------- */
  function initGallery(root) {
    var gals = (root || document).querySelectorAll('[data-lb-gal]:not([data-lb-ready])');
    gals.forEach(function (gal) {
      gal.setAttribute('data-lb-ready', '1');
      var slides = gal.querySelectorAll('[data-lb-slide]');
      var thumbs = gal.querySelectorAll('[data-lb-thumb]');
      if (slides.length < 2) return;

      function go(i) {
        slides.forEach(function (s, k) {
          s.classList.toggle('is-on', k === i);
        });
        thumbs.forEach(function (t, k) {
          t.classList.toggle('is-on', k === i);
          t.setAttribute('aria-selected', k === i ? 'true' : 'false');
        });
      }

      thumbs.forEach(function (t, i) {
        t.addEventListener('click', function () {
          go(i);
        });
      });

      gal.lbGoToMedia = function (mediaId) {
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].getAttribute('data-lb-media') === String(mediaId)) {
            go(i);
            return true;
          }
        }
        return false;
      };
    });
  }

  /* ---------- 5. Selector de variantes ---------- */
  function initVariants(root) {
    var forms = (root || document).querySelectorAll('[data-lb-pdp]:not([data-lb-ready])');
    forms.forEach(function (pdp) {
      pdp.setAttribute('data-lb-ready', '1');

      var dataEl = pdp.querySelector('[data-lb-variants]');
      if (!dataEl) return;
      var variants;
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }
      if (!variants || !variants.length) return;

      var idInput = pdp.querySelector('[data-lb-variant-id]');
      var priceEl = pdp.querySelector('[data-lb-price]');
      var wasEl = pdp.querySelector('[data-lb-was]');
      var btn = pdp.querySelector('[data-lb-add]');
      var stockEl = pdp.querySelector('[data-lb-stock]');
      var gal = document.querySelector('[data-lb-gal]');
      var groups = pdp.querySelectorAll('[data-lb-opt]');
      var textos = {
        add: pdp.getAttribute('data-txt-add') || 'Agregar al carrito',
        out: pdp.getAttribute('data-txt-out') || 'Agotado',
        pick: pdp.getAttribute('data-txt-pick') || 'Elige una opcion',
      };

      function current() {
        var picked = [];
        groups.forEach(function (g) {
          var on = g.querySelector('.lb-opt__btn.is-on');
          picked.push(on ? on.getAttribute('data-value') : null);
        });
        return picked;
      }

      function match(picked) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var ok = true;
          for (var k = 0; k < picked.length; k++) {
            if (picked[k] === null || v.options[k] !== picked[k]) {
              ok = false;
              break;
            }
          }
          if (ok) return v;
        }
        return null;
      }

      function markUnavailable(picked) {
        groups.forEach(function (g, gi) {
          g.querySelectorAll('.lb-opt__btn').forEach(function (b) {
            var test = picked.slice();
            test[gi] = b.getAttribute('data-value');
            var any = variants.some(function (v) {
              for (var k = 0; k < test.length; k++) {
                if (k !== gi && test[k] !== null && v.options[k] !== test[k]) return false;
              }
              return v.options[gi] === test[gi] && v.available;
            });
            b.classList.toggle('is-off', !any);
          });
        });
      }

      function label(btn, text) {
        if (!btn) return;
        var span = btn.querySelector(':scope > span') || btn.querySelector('span');
        if (span) span.textContent = text;
        else btn.textContent = text;
      }

      function apply() {
        var picked = current();
        markUnavailable(picked);

        // refleja la opcion elegida junto al nombre de la opcion
        groups.forEach(function (g) {
          var on = g.querySelector('.lb-opt__btn.is-on');
          var out = g.querySelector('[data-lb-opt-value]');
          if (on && out) out.textContent = on.textContent.trim();
        });

        var v = match(picked);

        if (!v) {
          if (btn) {
            btn.disabled = true;
            label(btn, textos.pick);
          }
          if (idInput) idInput.disabled = true;
          return;
        }

        if (idInput) {
          idInput.value = v.id;
          idInput.disabled = !v.available;
        }
        if (priceEl) priceEl.textContent = v.price_f;
        if (wasEl) {
          if (v.has_compare) {
            wasEl.textContent = v.compare_f;
            wasEl.hidden = false;
          } else {
            wasEl.hidden = true;
          }
        }
        if (btn) {
          btn.disabled = !v.available;
          btn.removeAttribute('aria-disabled');
          label(btn, v.available ? textos.add : textos.out);
        }
        if (stockEl) {
          stockEl.classList.remove('is-low', 'is-out');
          if (!v.available) {
            stockEl.classList.add('is-out');
            stockEl.querySelector('span').textContent =
              stockEl.getAttribute('data-out') || 'Agotado por ahora';
          } else if (v.inventory_quantity > 0 && v.inventory_quantity <= 5) {
            stockEl.classList.add('is-low');
            var lowTxt = (
              stockEl.getAttribute('data-low') || 'Ultimas {n} unidades'
            ).replace('{n}', v.inventory_quantity);
            if (v.inventory_quantity === 1) {
              lowTxt = lowTxt.replace('unidades', 'unidad');
            }
            stockEl.querySelector('span').textContent = lowTxt;
          } else {
            stockEl.querySelector('span').textContent =
              stockEl.getAttribute('data-ok') || 'Disponible, despacho en 24 h habiles';
          }
        }
        if (gal && gal.lbGoToMedia && v.featured_media_id) {
          gal.lbGoToMedia(v.featured_media_id);
        }

        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      groups.forEach(function (g) {
        g.addEventListener('click', function (ev) {
          var b = ev.target.closest('.lb-opt__btn');
          if (!b) return;
          g.querySelectorAll('.lb-opt__btn').forEach(function (o) {
            o.classList.toggle('is-on', o === b);
          });
          apply();
        });
      });

      apply();
    });
  }

  /* ---------- arranque ---------- */
  function boot(root) {
    initReveals(root);
    initBrain(root);
    initFaq(root);
    initGallery(root);
    initVariants(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  // El editor de Shopify recarga secciones sueltas: re-inicializa lo que llegue.
  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
})();
